import { replacePathParams } from '@/api/utils';

export const routePaths = {
  setBenchmark: '/routeservice/benchmarks',
  recommendedFlights: '/routeservice/recommended-flights',
  createHereMapsToken: '/routeservice/heremaps/token',
  suggestedRoutesMetrics: '/routeservice/metrics/suggested-routes',
  aircraftUtilization: '/routeservice/aircraft-utilization',
  // route service v2
  getBenchmarkById: '/routeservice/benchmarks/v2/:benchmarkId',
  getLogisticsList: '/routeservice/logistics',
  createLogistics: '/routeservice/logistics/:caseId',
  getLogisticsById: '/routeservice/logistics/:logisticsId',
  getLogisticsSnapshotByVersion: '/routeservice/logistics/:logisticsId/snapshots/:version',
  // Suggested routes
  addSuggestedRoutes: '/routeservice/logistics/:logisticsId/suggested-routes',
  addPartialSuggestedRoutes: '/routeservice/logistics/:logisticsId/suggested-routes/partial',
  // Hubs
  assignDepartureHub: '/routeservice/logistics/:logisticsId/routes/:routeId/assign-departure-hub/:hubId',
  unassignDepartureHub: '/routeservice/logistics/:logisticsId/routes/:routeId/unassign-departure-hub',
  assignArrivalHub: '/routeservice/logistics/:logisticsId/routes/:routeId/assign-arrival-hub/:hubId',
  unassignArrivalHub: '/routeservice/logistics/:logisticsId/routes/:routeId/unassign-arrival-hub',
  // TMDX Avia Leg
  addTmdxAviaLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tmdx-jet-avia',
  updateTmdxAviaLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tmdx-jet-avia',
  // Supplemental Lift Avia Leg
  addSupplementalLiftLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/supplemental-lift-avia',
  updateSupplementalLiftLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/supplemental-lift-avia',
  // TX Center Avia Leg
  addTxCenterAviaLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tx-center-provider-avia',
  updateTxCenterAviaLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tx-center-provider-avia',
  // Commercial Flight Leg
  addCommercialLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/commercial-flight-avia',
  addSabreCommercialLegs: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/sabre-commercial-avia',
  updateSabreCommercialLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/sabre-commercial-avia',
  updateCommercialLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/commercial-flight-avia',
  removeSabreCommercialLegs:
    '/routeservice/logistics/:logisticsId/routes/:routeId/legs/sabre-commercial-avia-groups/:sabreGroupId',
  // TMDX Affiliate Ground Leg
  addTmdxAffiliateLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tmdx-affiliate-ground',
  updateTmdxAffiliateLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tmdx-affiliate-ground',
  // TMDX Drive Affiliate Ground Leg
  addTmdxDriveAffiliateLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tmdx-drive-affiliate-ground',
  updateTmdxDriveAffiliateLeg:
    '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tmdx-drive-affiliate-ground',
  // TX Center Ground Leg
  addTxCenterGroundLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tx-center-provider-ground',
  updateTxCenterGroundLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tx-center-provider-ground',
  // Curri Service Ground Leg
  addCurriServiceLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/curri-service-ground',
  updateCurriServiceLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/curri-service-ground',
  // TMDX Drive Teds Ground Leg
  addTmdxDriveTedsGroundLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/tmdx-drive-teds-ground',
  updateTmdxDriveTedsGroundLeg:
    '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/tmdx-drive-teds-ground',
  // Self Serviced Ground Leg
  addSelfServicedGroundLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/self-serviced-ground',
  updateSelfServicedGroundLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/self-serviced-ground',
  // Accommodation Leg
  addAccommodationLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/accommodation',
  updateAccommodationLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId/accommodation',
  // Remove Leg
  removeLeg: '/routeservice/logistics/:logisticsId/routes/:routeId/legs/:legId',
  // Remove Route
  removeRoute: '/routeservice/logistics/:logisticsId/routes/:routeId',
  // Remove Resource
  removeResource: '/routeservice/logistics/:logisticsId/resources/:resourceId',
  // Logs
  getLogisticsLogs: '/routeservice/logistics/:logisticsId/logs',
  // Device Tracking
  getDeviceTrackingList: '/routeservice/device-tracking',
  getDeviceTrackingById: '/routeservice/device-tracking/:deviceTrackingId',
  getDeviceTrackingByCaseId: '/routeservice/device-tracking/case/:caseId',
  patchDeviceTrackingDisplaySettings: '/routeservice/device-tracking/:deviceTrackingId/display-settings',
  getDeviceTrackingLogs: '/routeservice/device-tracking/:deviceTrackingId/logs',
} as const;

export const getRouteApiUrl = {
  setBenchmark: () => routePaths.setBenchmark,
  recommendedFlights: () => routePaths.recommendedFlights,
  getBenchmarkById: (benchmarkId: string) => replacePathParams(routePaths.getBenchmarkById, { benchmarkId }),
  createHereMapsToken: () => routePaths.createHereMapsToken,
  suggestedRoutesMetrics: () => routePaths.suggestedRoutesMetrics,
  aircraftUtilization: () => routePaths.aircraftUtilization,
  // route service v2
  getLogisticsList: () => routePaths.getLogisticsList,
  createLogistics: (caseId: string) => replacePathParams(routePaths.createLogistics, { caseId }),
  getLogisticsById: (logisticsId: string) => replacePathParams(routePaths.getLogisticsById, { logisticsId }),
  getLogisticsSnapshotByVersion: (logisticsId: string, version: string) =>
    replacePathParams(routePaths.getLogisticsSnapshotByVersion, { logisticsId, version }),
  // Suggested routes
  addSuggestedRoutes: (logisticsId: string) => replacePathParams(routePaths.addSuggestedRoutes, { logisticsId }),
  addPartialSuggestedRoutes: (logisticsId: string) =>
    replacePathParams(routePaths.addPartialSuggestedRoutes, { logisticsId }),
  // Hubs
  assignDepartureHub: (logisticsId: string, routeId: string, hubId: string) =>
    replacePathParams(routePaths.assignDepartureHub, { logisticsId, routeId, hubId }),
  unassignDepartureHub: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.unassignDepartureHub, { logisticsId, routeId }),
  assignArrivalHub: (logisticsId: string, routeId: string, hubId: string) =>
    replacePathParams(routePaths.assignArrivalHub, { logisticsId, routeId, hubId }),
  unassignArrivalHub: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.unassignArrivalHub, { logisticsId, routeId }),
  // TMDX Avia Leg
  addTmdxAviaLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTmdxAviaLeg, { logisticsId, routeId }),
  updateTmdxAviaLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTmdxAviaLeg, { logisticsId, routeId, legId }),
  // Supplemental Lift Avia Leg
  addSupplementalLiftLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addSupplementalLiftLeg, { logisticsId, routeId }),
  updateSupplementalLiftLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateSupplementalLiftLeg, { logisticsId, routeId, legId }),
  // TX Center Avia Leg
  addTxCenterAviaLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTxCenterAviaLeg, { logisticsId, routeId }),
  updateTxCenterAviaLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTxCenterAviaLeg, { logisticsId, routeId, legId }),
  // Commercial Flight Leg
  addCommercialLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addCommercialLeg, { logisticsId, routeId }),
  addSabreCommercialLegs: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addSabreCommercialLegs, { logisticsId, routeId }),
  updateCommercialLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateCommercialLeg, { logisticsId, routeId, legId }),
  updateSabreCommercialLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateSabreCommercialLeg, { logisticsId, routeId, legId }),
  removeSabreCommercialLegs: (logisticsId: string, routeId: string, sabreGroupId: string) =>
    replacePathParams(routePaths.removeSabreCommercialLegs, { logisticsId, routeId, sabreGroupId }),
  // TMDX Affiliate Ground Leg
  addTmdxAffiliateLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTmdxAffiliateLeg, { logisticsId, routeId }),
  updateTmdxAffiliateLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTmdxAffiliateLeg, { logisticsId, routeId, legId }),
  // TMDX Drive Affiliate Ground Leg
  addTmdxDriveAffiliateLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTmdxDriveAffiliateLeg, { logisticsId, routeId }),
  updateTmdxDriveAffiliateLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTmdxDriveAffiliateLeg, { logisticsId, routeId, legId }),
  // TX Center Ground Leg
  addTxCenterGroundLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTxCenterGroundLeg, { logisticsId, routeId }),
  updateTxCenterGroundLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTxCenterGroundLeg, { logisticsId, routeId, legId }),
  // Curri Service Ground Leg
  addCurriServiceLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addCurriServiceLeg, { logisticsId, routeId }),
  updateCurriServiceLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateCurriServiceLeg, { logisticsId, routeId, legId }),
  // TMDX Drive Teds Ground Leg
  addTmdxDriveTedsGroundLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addTmdxDriveTedsGroundLeg, { logisticsId, routeId }),
  updateTmdxDriveTedsGroundLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateTmdxDriveTedsGroundLeg, { logisticsId, routeId, legId }),
  // Self Serviced Ground Leg
  addSelfServicedGroundLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addSelfServicedGroundLeg, { logisticsId, routeId }),
  updateSelfServicedGroundLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateSelfServicedGroundLeg, { logisticsId, routeId, legId }),
  // Accommodation Leg
  addAccommodationLeg: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.addAccommodationLeg, { logisticsId, routeId }),
  updateAccommodationLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.updateAccommodationLeg, { logisticsId, routeId, legId }),
  // Remove Leg
  removeLeg: (logisticsId: string, routeId: string, legId: string) =>
    replacePathParams(routePaths.removeLeg, { logisticsId, routeId, legId }),
  // Remove Route
  removeRoute: (logisticsId: string, routeId: string) =>
    replacePathParams(routePaths.removeRoute, { logisticsId, routeId }),
  // Remove Resource
  removeResource: (logisticsId: string, resourceId: string) =>
    replacePathParams(routePaths.removeResource, { logisticsId, resourceId }),
  // Logistics Logs
  getLogisticsLogs: (logisticsId: string) => replacePathParams(routePaths.getLogisticsLogs, { logisticsId }),
  // Device Tracking
  getDeviceTrackingList: () => routePaths.getDeviceTrackingList,
  getDeviceTrackingById: (deviceTrackingId: string) =>
    replacePathParams(routePaths.getDeviceTrackingById, { deviceTrackingId }),
  getDeviceTrackingByCaseId: (caseId: string) => replacePathParams(routePaths.getDeviceTrackingByCaseId, { caseId }),
  patchDeviceTrackingDisplaySettings: (deviceTrackingId: string) =>
    replacePathParams(routePaths.patchDeviceTrackingDisplaySettings, { deviceTrackingId }),
  getDeviceTrackingLogs: (deviceTrackingId: string) =>
    replacePathParams(routePaths.getDeviceTrackingLogs, { deviceTrackingId }),
};
